import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as cartActions from '../../actions/cart';
import * as frameActions from '../../actions/frames';
import * as orderActions from '../../actions/orders';
import * as settingActions from '../../actions/settings';
import AppointmentPage from './AppointmentPage';

const mapStateToProps = ({
  settings, product, order, frames: { timeslots, frames, ...framesProps },
}) => ({
  frames,
  order,
  timeslots,
  ...framesProps,
  ...settings,
  locale: window.bta.locale.substr(0, 2),
  isDemo: window.bta.isDemo,
  googleApiKey: window.bta.googleApiKey,
  durations: product.data.durations,
  locations: product.data.locations,
  resources: product.data.resources,
  options: product.data.options,
  minDate: product.data.mindate,
  maxDate: product.data.maxdate,
  variants: product.data.variants,
  productTitle: product.data.title,
  capacity: product.data.capacity,
  additionalDetails: order.additionalDetails,
  onTrigger: window.xprops ? window.xprops.onTrigger : null,
  shopBeginningOfWeek: settings.defaultSetting.shop_beginning_of_week,
  shopDatepickerTimeInterval: settings.shop_datepicker_time_interval,
  shopDateFormat: settings.shop_date_format,
});

const mapDispatchToProps = (dispatch) => ({
  frameActions: bindActionCreators({ ...frameActions }, dispatch),
  orderActions: bindActionCreators({ ...orderActions }, dispatch),
  cartActions: bindActionCreators({ ...cartActions }, dispatch),
  settingActions: bindActionCreators({ ...settingActions }, dispatch),
});

const AppointmentPageConnected = connect(
  mapStateToProps,
  mapDispatchToProps,
)(AppointmentPage);

export default AppointmentPageConnected;
